import { Component, OnInit, Input } from '@angular/core';
import { AdditionalIncomeSource } from '../models/argyle';
import { ApplicantDataService } from '../services/applicant-data.service';

@Component({
  selector: 'app-income-source-list',
  templateUrl: './income-source-list.component.html',
  styleUrls: ['./income-source-list.component.less']
})
export class IncomeSourceListComponent implements OnInit{
  @Input() incomeSources: AdditionalIncomeSource[] = []
  
  constructor(public appdata: ApplicantDataService) { }
  ngOnInit(): void {
   
  }



  getSourceTypeName(id: number)
  {
    return this.appdata.incomeSourceTypes.find(st => {return st.id == id;}).name;
  }


   
  
}
